<template>
  <div>
    <div>
     
      <el-date-picker 
        size="medium"
        value-format="yyyy-MM-dd"
        v-model="startDate"
        type="date"
        placeholder="选择开始日期"
      >
      </el-date-picker>
      <el-date-picker
        size="medium"
        value-format="yyyy-MM-dd"
        v-model="endDate"
        type="date"
        placeholder="选择结束日期"
      >
      </el-date-picker>
      <el-input clearable v-model="search" style="width:200px" size="medium"  placeholder="请输入站点名称"></el-input>

      <el-button size="medium" @click="load">筛选</el-button>
    </div>
    <el-divider></el-divider>
    <div>
      <el-table :data="list" border>
        <el-table-column align="center" type="index" width="50">
        </el-table-column>
        <el-table-column align="center" label="站点">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>站点名称: {{ scope.row.siteName }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{ scope.row.siteName }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column align="center" label="访问资源">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.resName }}</span>
          </template>
        </el-table-column>
         <el-table-column align="center" label="点击数">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.clickNum }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page
      @givePageIndex="getpage"
      :index="page"
      :pageSize="pageSize"
      :total="total"
    ></page>
  </div>
</template>

<script>

import page from "../../components/pages";
export default {
  components: {
    page,
  },
  mounted() {
    this.load();
    // this.getOrgList();
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      search:'',
      orgBack: false,
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
    };
  },
  methods: {
    load() {
      let obj = {
        pageNo: this.page,
        pageSize: this.pageSize,
        startTime: this.startDate,
        endTime: this.endDate,
        search: this.search,
      };
      console.log(obj);
      this.$api.thirdSiteClick(obj).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.list = res.data.data.records;
          this.page = res.data.data.current;
          this.pageSize = res.data.data.size;
          this.total = res.data.data.total;
        }
      });
    },
    getpage(x) {
      //分页
      console.log(x);
      this.page = x;
      this.load();
    },
  },
};
</script>

<style scoped>
</style>